import styled from 'styled-components';
import { gridSizes, weights } from 'utils/style';
import Title from 'components/summary/Title/container';

export default styled(Title)`
  h1 {
    color: var(--grey900);
    font-size: 32px;
    margin: 0;
    font-weight: ${weights('medium')};
    line-height: 38px;
  }
  h2 {
    color: var(--grey700);
    font-size: ${gridSizes('M')};
    margin: 0;
    margin-top: 3px;
    font-weight: ${weights('regular')};
    line-height: 19px;
  }
`;
